<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader class="mc-page-three" :title="title" hasBreadcrumb :items="breadcrumbItems" />
      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <McButtonBack class="d-inline-block me-2" :href="hrefBtnBack" />
      </div>
    </div>
    <McGrapqlTable
      :key="'download-video-histories'"
      :apiClient="query"
      :fields="localizeFields"
      :hasCheckbox="false"
      :searchable="false"
      :isSelectableField="false"
      :withCard="true"
      :stickyHeader="false"
      :customButton="true"
      :hasFilter="true"
      :hideCountData="true"
      :hideGoToFirstLastPagination="true"
      :activeFilters="activeFilters"
      trackBy="id"
    >
      <template #button-filter="{ isSelected, showDeleteModal, selectedIds }">
        <div class="d-flex justify-content-between mb-3">
          <McInlineFilter
            :activeKeys="activeFilters['status']"
            @update:activeKeys="handleChangeActiveFilters([{ key: 'status', values: $event }])"
          />

          <ModalFilter
            :isSelected="isSelected"
            :showDeleteModal="showDeleteModal"
            :activeFilters="activeFilters"
            @handleChangeActiveFilters="handleChangeActiveFilters"
          />
        </div>
      </template>

      <template #viewManager="{ handleSetDataFields, dataFields, initialFields }">
        <McFilterSelect
          :defaultColumnOrder="fields"
          :currentColumnOrder="dataFields"
          @setColumn="handleSetDataFields"
          @setField="handleFieldShow"
        />
      </template>

      <!--  eslint-disable-next-line vue/valid-v-slot -->
      <template #cell(vehicle.licensePlate)="data">
        <span
          class="mc-download-video-history__license-plate"
          :class="{
            'download-in-progress': data.item.statusDownload === 'I',
            'download-failed': data.item.statusDownload === 'F',
          }"
          :title="tooltipLicensePlate(data.item.statusDownload)"
          @click="handleClickShowVideo(data.item)"
        >
          {{ data.item.vehicle.licensePlate }}
        </span>
      </template>
      <template #cell(videoUrl)="data">
        <span v-if="data.item.statusDownload === 'I'" class="mc-status mc-status--blue">{{
          $t('global.action.uploadProcess')
        }}</span>
        <span v-if="data.item.statusDownload === 'F'" class="mc-status mc-status--red">{{
          $t('global.action.notAvailable')
        }}</span>
        <template v-if="data.item.statusDownload === 'S'">
          <McButton
            :text="
              loadingDownloadIds.includes(data.item.id)
                ? $t('global.processing')
                : $t('global.action.download')
            "
            :icon="loadingDownloadIds.includes(data.item.id) ? undefined : 'icon-outline_download'"
            :loading="loadingDownloadIds.includes(data.item.id)"
            size="sm"
            @click="handleClickDownloadVideo(data.item)"
          />
        </template>
      </template>
      <template #cell(startTime)="data">
        {{ data.item.startTime }}
      </template>
      <template #cell(endTime)="data">
        {{ data.item.endTime }}
      </template>
      <template #cell(downloadOn)="data">
        {{ data.item.downloadOn }}
      </template>
      <template #cell(convertedChannel)="data">
        {{ $t('trackVideo.camera') + ' ' + data.item.calculatedChannel }}
      </template>
    </McGrapqlTable>
    <ModalDownloadSaved
      :videoData="videoPlayerData"
      :loadingDownload="videoPlayerData ? loadingDownloadIds.includes(videoPlayerData.id) : false"
      @resetVideoData="resetVideoData"
      @clickDownload="handleClickDownloadVideo"
    />
  </Layout>
</template>
<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header-v2'
import Layout from '@/router/layouts/main'
import McGrapqlTable from '@/components/McGrapqlTable'
import McFilterSelect from '@/components/McFilterSelect'
import McInlineFilter from '@/components/McInlineFilter'
import McButtonBack from '@/components/McButtonBack'
import McButton from '@/components/McButton'
import ModalFilter from './DownloadFilter'
import ModalDownloadSaved from './ModalDownloadSaved'
import { Helper } from '@/mixin/helper'
import { GET_DOWNLOAD_VIDEO_HISTORIES } from '@/services/api/videoHistory/videos'
import { MixPanel } from '@/mixin/mixpanel'
import moment from 'moment'
import cloneDeep from 'lodash/cloneDeep'
import { mapGetters } from 'vuex'
import { DEVICE_CODE_LIST } from '../../../helpers/device-code'

moment.locale('id')

export default {
  name: 'DownloadItem',
  page: {
    title: 'Riwayat Unduhan Video',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McGrapqlTable,
    McFilterSelect,
    McButtonBack,
    McInlineFilter,
    ModalFilter,
    ModalDownloadSaved,
    McButton,
  },
  mixins: [Helper, MixPanel],

  data() {
    return {
      created: true,
      fieldShow: JSON.parse(localStorage.getItem('downloadVideoHistoryFields')),
      filterState: {
        all: true,
        draft: false,
        confirmation: false,
        inProgress: false,
        validation: false,
        done: false,
      },
      activeFilters: {
        channel: null,
        periode: [
          this.momentAdd(new Date(), -3, 'days').format('YYYY-MM-DD 00:00'),
          moment().format('YYYY-MM-DD HH:mm'),
        ],
        vehicleId: [],
      },
      filter: [],
      videoPlayerData: null,
      loadingDownloadIds: [],
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),

    title() {
      return this.$t('trackVideo.historyVideoDownload')
    },

    isVideoDemo() {
      const email = this.$store.state.identity.whoami.email

      return (
        (email === 'livedemo@mceasy.com' || email === 'demo@mceasy.co.id') &&
        window.location.host === 'demo.mceasy.com' &&
        process.env.VUE_APP_ENV === 'production' &&
        this.$route.query?.isDemo
      )
    },

    hrefBtnBack() {
      if (this.$route.query.modalShowDownloadVideoId && this.$route.query.videoHistoryVehicleId) {
        return `/video-history/?vehicleId=${this.$route.query.videoHistoryVehicleId}`
      }
      return undefined
    },

    breadcrumbItems() {
      const arr = window.location.pathname.split('/')

      const isFromMenuTrackvision = arr[1] === 'video-history' && arr[2] === 'download'
      let prevPage
      if (isFromMenuTrackvision) {
        prevPage = this.$route.query.prevPage
      }
      const getBreadcrumbItems = () => {
        const breadcrumb = {
          text: 'Live Streaming',
          url: '/live-streaming/',
        }
        if (prevPage === 'video-history') {
          breadcrumb.text = this.$t('menuitems.videoHistory.text')
          const fromHistoryVehicleId = this.$route.query.videoHistoryVehicleId
          if (fromHistoryVehicleId) {
            breadcrumb.url = `/video-history/?vehicleId=${fromHistoryVehicleId}`
          } else {
            breadcrumb.url = '/video-history/'
          }
        }
        return breadcrumb
      }

      return [
        {
          text: isFromMenuTrackvision
            ? getBreadcrumbItems().text
            : this.$t('menuitems.trackVideo.title'),
          to: isFromMenuTrackvision ? getBreadcrumbItems().url : '/trackvideo-2/',
        },
        {
          text: this.$t('trackVideo.historyVideoDownload'),
        },
      ]
    },
    fields() {
      return [
        {
          key: 'vehicle.licensePlate',
          label: this.$t('global.object.licensePlate'),
          isSortable: true,
          isLocked: true,
          shown: true,
        },
        {
          key: 'vehicle.vehicleType.type',
          label: this.$t('global.field.vehicleType'),
          isSortable: true,
          shown: false,
        },
        {
          key: 'vehicle.vehicleType.category',
          label: this.$t('setting.list.fleetSetting.fleetCategory'),
          isSortable: true,
          shown: false,
        },
        {
          key: 'convertedChannel',
          label: this.$t('trackVideo.camera'),
          isSortable: true,
          shown: true,
        },
        {
          key: 'startTime',
          label: this.$t('videoHistory.startVideo'),
          isSortable: true,
          isLocked: true,
          shown: true,
        },
        {
          key: 'endTime',
          label: this.$t('videoHistory.endVideo'),
          isSortable: true,
          isLocked: true,
          shown: true,
        },
        {
          key: 'downloadOn',
          label: this.$t('videoHistory.downloadDate'),
          isSortable: true,
          shown: true,
        },
        {
          key: 'users.fullname',
          label: this.$t('global.field.username'),
          isSortable: true,
          shown: false,
        },
        {
          key: 'videoUrl',
          label: this.$t('global.action.video'),
          isSortable: false,
          isLocked: true,
          shown: true,
        },
      ]
    },

    localizeFields() {
      const fieldShow = this.fieldShow
      const fields = fieldShow ? fieldShow.column : this.fields
      const field = cloneDeep(fields)
      return field
    },

    query() {
      const self = this
      return {
        get: self.getQueryDvh,
      }
    },
    tooltipLicensePlate() {
      return (statusDownload) => {
        if (statusDownload === 'I') {
          return this.$t('videoHistory.tooltip.videoInProgress')
        } else if (statusDownload === 'F') {
          return this.$t('videoHistory.tooltip.videoFailed')
        } else {
          return ''
        }
      }
    },
  },

  created() {
    this.setDefaultFields()
  },

  async mounted() {
    const downloadId = this.$route.query?.modalShowDownloadVideoId

    if (this.$route.query?.isDemo && downloadId !== undefined) {
      const _dataDemo = JSON.parse(sessionStorage.getItem('tv2VideoHistoryDemoData'))[
        parseInt(downloadId)
      ]

      this.videoPlayerData = {
        id: _dataDemo.downloadId,
        vehicle: {
          licensePlate: _dataDemo.licensePlate,
          vehicleType: {
            type: _dataDemo.vehicleType,
            category: _dataDemo.vehicleCategory,
          },
        },
        calculatedChannel: _dataDemo.convertedChannel,
        startTime: this.momentDMYH(_dataDemo.startTime),
        endTime: this.momentDMYH(_dataDemo.endTime),
        downloadOn: this.momentDMYH(_dataDemo.downloadOn),
        users: {
          fullname: _dataDemo.fullname,
        },
        videoUrl: _dataDemo.url,
        mediaFilename: _dataDemo.mediaFilename,
        statusDownload: _dataDemo.status,
      }
      this.$bvModal.show('video-saved')
      return
    }

    if (downloadId) {
      const rangesThisDay = this.getRangesThisDay()
      const filter = {
        allUsers: true,
        startDate: this.formatDateToUtc(rangesThisDay[0]),
        endDate: this.formatDateToUtc(rangesThisDay[0]),
        downloadId: [Number(downloadId)],
      }
      const data = await this.$store.dispatch('vehicle/requestDownloadVideoHistories', { filter })
      this.videoPlayerData = {
        id: data[0].downloadId,
        vehicle: {
          licensePlate: data[0].vehicle.parentVehicle?.licensePlate ?? data[0].vehicle.licensePlate,
          vehicleType: {
            type: data[0].vehicle.vehicleType.type,
            category: data[0].vehicle.vehicleType.category,
          },
        },
        convertedChannel: data[0].convertedChannel,
        startTime: this.momentDMYH(data[0].startTime),
        endTime: this.momentDMYH(data[0].endTime),
        downloadOn: this.momentDMYH(data[0].downloadOn),
        users: {
          fullname: data[0].users.fullname,
        },
        videoUrl: data[0].url,
        mediaFilename: data[0].mediaFilename,
        statusDownload: data[0].status,
      }
      await this.$nextTick()
      this.$bvModal.show('video-saved')
    }
  },

  methods: {
    async getQueryDvh(filter) {
      try {
        const periode = [
          this.momentAdd(new Date(), -3, 'days').format('YYYY-MM-DD 00:00'),
          moment().format('YYYY-MM-DD HH:mm'),
        ]

        const generateOrderBy = () => {
          if (!filter?.orderBy)
            return [JSON.stringify({ downloadOn: 'desc' }), JSON.stringify({ startTime: 'asc' })]
          let _orderBy = filter.orderBy
            .map((orderBy) => JSON.parse(orderBy))
            .map((orderBy) => {
              if (orderBy?.['vehicle.licensePlate']) {
                return {
                  vehicle: {
                    licensePlate: Object.values(orderBy)[0],
                  },
                }
              }
              if (orderBy?.['vehicle.vehicleType.type']) {
                return {
                  vehicle: {
                    vehicleType: {
                      type: Object.values(orderBy)[0],
                    },
                  },
                }
              }
              if (orderBy?.['vehicle.vehicleType.category']) {
                return {
                  vehicle: {
                    vehicleType: {
                      category: Object.values(orderBy)[0],
                    },
                  },
                }
              }
              if (orderBy?.['users.fullname']) {
                return {
                  users: {
                    fullname: Object.values(orderBy)[0],
                  },
                }
              }
              return orderBy
            })
          _orderBy = _orderBy.map((orderBy) => JSON.stringify(orderBy))
          return _orderBy
        }

        const defaultPeriode = {
          downloadOn: {
            start: this.isVideoDemo
              ? moment(periode[0]).format('YYYY-MM-DDTHH:mm:ss')
              : this.formatDateToUtc(periode[0]),
            end: this.isVideoDemo
              ? moment(periode[1]).format('YYYY-MM-DDTHH:mm:59')
              : this.formatDateToUtc(periode[1]),
          },
        }

        let _periodeFilterActive = this.activeFilters.periode
        if (_periodeFilterActive?.[0] && _periodeFilterActive?.[1]) {
          _periodeFilterActive = [
            moment(_periodeFilterActive[0]).format('YYYY-MM-DD 00:00'),
            moment(_periodeFilterActive[1]).format('YYYY-MM-DD 23:59'),
          ]
        }

        const periodeFilterActive =
          !_periodeFilterActive?.[0] && !_periodeFilterActive?.[1]
            ? defaultPeriode
            : {
                downloadOn: {
                  start: this.isVideoDemo
                    ? moment(_periodeFilterActive[0]).format('YYYY-MM-DDTHH:mm:ss')
                    : this.formatDateToUtc(_periodeFilterActive[0]),
                  end: this.isVideoDemo
                    ? moment(_periodeFilterActive[1]).format('YYYY-MM-DDTHH:mm:59')
                    : this.formatDateToUtc(_periodeFilterActive[1]),
                },
              }

        const filterVehicleActive =
          this.activeFilters?.vehicleId && this.activeFilters?.vehicleId?.length
            ? this.activeFilters?.vehicleId
            : undefined

        const channelFilterActive =
          this.activeFilters.channel?.length === 0 || !this.activeFilters.channel
            ? undefined
            : this.activeFilters.channel.map((item) => item.value)

        if (this.isVideoDemo) {
          const filteredDataDemo = () => {
            if (
              this.$route.query?.isDemo &&
              this.$route.query?.modalShowDownloadVideoId !== undefined
            ) {
              const dataDemo = JSON.parse(sessionStorage.getItem('tv2VideoHistoryDemoData'))
              dataDemo.forEach((data) => {
                this.$store.commit('vehicle/addDvhPollingData', {
                  downloadId: data.downloadId,
                  data,
                })
              })
            }
            let _data = []
            _data =
              this.$route.query?.isDemo && this.$route.query?.modalShowDownloadVideoId !== undefined
                ? JSON.parse(sessionStorage.getItem('tv2VideoHistoryDemoData'))
                : Object.keys(this.$store.state.vehicle.dvhPollingData).map(
                    (key) => this.$store.state.vehicle.dvhPollingData[key]
                  )
            if (filterVehicleActive) {
              _data = _data.filter((data) =>
                filterVehicleActive.includes(data.vehicleId.toString())
              )
            }
            _data = _data.filter(
              (data) => channelFilterActive ?? [1, 2, 3, 4].includes(data.convertedChannel)
            )

            if (periodeFilterActive.startDate && periodeFilterActive.endDate) {
              _data = _data.filter((data) =>
                this.isBetweenDate(
                  data.downloadOn,
                  periodeFilterActive.startDate,
                  periodeFilterActive.endDate
                )
              )
            }
            if (filter.search) {
              _data = _data.filter(
                (data) =>
                  data.vehicle.licensePlate.toLowerCase().includes(filter.search.toLowerCase()) ||
                  data.vehicle.vehicleType.type
                    .toLowerCase()
                    .includes(filter.search.toLowerCase()) ||
                  data.vehicle.vehicleType.category
                    .toLowerCase()
                    .includes(filter.search.toLowerCase()) ||
                  data.users.fullname.toLowerCase().includes(filter.search.toLowerCase())
              )
            }
            if (filter.orderBy) {
              _data = (() => {
                const sortByFields = (fields) => {
                  return (a, b) => {
                    for (let field of fields) {
                      const [key, order = 'asc'] = field.split(':')
                      const multiplier = order === 'asc' ? 1 : -1

                      let valueA = a[key]
                      let valueB = b[key]

                      // Check if the field is a date and convert to Date object for comparison
                      if (key === 'startTime' || key === 'endTime' || key === 'downloadOn') {
                        valueA = new Date(valueA)
                        valueB = new Date(valueB)
                      }

                      if (valueA < valueB) return -1 * multiplier
                      if (valueA > valueB) return 1 * multiplier
                    }
                    return 0
                  }
                }
                const _tempData = _data.map((data) => ({
                  ...data,
                  licensePlate: data.vehicle.licensePlate,
                  vehicleType: data.vehicle.vehicleType.type,
                  vehicleCategory: data.vehicle.vehicleType.category,
                  fullname: data.users.fullname,
                }))
                const mapKeyOrderBy = filter.orderBy
                  .map((orderBy) => JSON.parse(orderBy))
                  .map((data) => {
                    if (Object.hasOwn(data, 'vehicle.licensePlate'))
                      return 'licensePlate' + ':' + data['vehicle.licensePlate']
                    if (Object.hasOwn(data, 'vehicle.vehicleType.type'))
                      return 'vehicleType' + ':' + data['vehicle.vehicleType.type']
                    if (Object.hasOwn(data, 'vehicle.vehicleType.category'))
                      return 'vehicleCategory' + ':' + data['vehicle.vehicleType.category']
                    if (Object.hasOwn(data, 'users.fullname'))
                      return 'fullname' + ':' + data['users.fullname']
                    const objEntries = Object.entries(data)
                    return objEntries[0][0] + ':' + objEntries[0][1]
                  })

                _tempData.sort(sortByFields(mapKeyOrderBy))

                return _tempData
              })()
            }

            return _data.map((data, index) => {
              return {
                id: index,
                vehicle: {
                  licensePlate: data.licensePlate,
                  vehicleType: {
                    type: data.vehicleType,
                    category: data.vehicleCategory,
                  },
                },
                calculatedChannel: data.convertedChannel,
                startTime: this.momentDMYH(data.startTime),
                endTime: this.momentDMYH(this.momentAdd(data.startTime, 1, 'minute')),
                downloadOn: this.momentDMYH(data.downloadOn),
                users: { fullname: data.fullname },
                videoUrl: data.url,
                mediaFilename: data.mediaFilename,
                statusDownload: data.status,
              }
            })
          }
          await this.delay(500)

          return {
            pagination: {
              page: filter.pagination.page,
              show: filter.pagination.show,
              total: Object.keys(this.$store.state.vehicle.dvhPollingData).length,
            },
            data: filteredDataDemo().slice(
              (filter.pagination.page - 1) * filter.pagination.show,
              filter.pagination.page * filter.pagination.show
            ),
          }
        }

        const filterPagination = filter.pagination

        const response = await this.$apollo.query({
          query: GET_DOWNLOAD_VIDEO_HISTORIES,
          fetchPolicy: 'no-cache',
          variables: {
            filter: {
              allUsers: true,
              ...periodeFilterActive,
              ...filter,
              identifier: ['HistoricalVideo'],
              convertedChannel: channelFilterActive,
              channel: channelFilterActive,
              vehicleId: filterVehicleActive,
              orderBy: generateOrderBy(),
            },
          },
        })

        const responsePagination =
          response.data.downloadVideoHistories.downloadVideoHistories.pagination

        const dataRows = response.data.downloadVideoHistories.downloadVideoHistories.data
        const totalRows = dataRows.length
        await this.$nextTick()
        let calculatedTotalCount
        if (totalRows < responsePagination.show) {
          calculatedTotalCount = (responsePagination.page - 1) * responsePagination.show + totalRows
        } else {
          calculatedTotalCount = responsePagination.page * responsePagination.show + 1
        }

        return {
          pagination: {
            ...response.data.downloadVideoHistories.downloadVideoHistories.pagination,
            // This is to forced component to assume that is always there next page if current page is full data
            // cause this datatable is special case !
            total: calculatedTotalCount,
          },
          data: dataRows.map((row) => {
            return {
              id: row.downloadId,
              vehicle: {
                licensePlate: row.vehicle.parentVehicle
                  ? row.vehicle.parentVehicle?.licensePlate
                  : row.vehicle.licensePlate,
                vehicleType: {
                  type: row.vehicle.vehicleType.type,
                  category: row.vehicle.vehicleType.category,
                },
              },
              calculatedChannel: DEVICE_CODE_LIST.CONCOX_CAMERA.includes(
                row.vehicle.device.deviceCode
              )
                ? row.channel
                : row.convertedChannel,
              startTime: this.momentDMYH(
                this.convertUtcToLocalDate(row.startTime, row.vehicle.device?.timezone ?? 7)
              ),
              endTime: this.momentDMYH(
                this.convertUtcToLocalDate(row.endTime, row.vehicle.device?.timezone ?? 7)
              ),
              downloadOn: this.momentDMYH(row.downloadOn),
              users: { fullname: row.users.fullname },
              videoUrl: row.url,
              mediaFilename: row.mediaFilename,
              statusDownload: row.status,
            }
          }),
        }
      } catch (error) {
        console.error(error)
        this.$mcToast.error(error?.message ?? this.$t('global.somethingWentWrong'))
      }
    },
    handleChangeActiveFilters(filters) {
      filters.forEach((filter) => {
        // to reset the filter values
        this.$delete(this.activeFilters, filter.key)

        // to prevent set the filter in activeFilters if values are null, undefined, or empty string
        if (
          filter.values === null ||
          filter.values === undefined ||
          filter.values === '' ||
          filter.values === false
        )
          return
        // to prevent set the filter in activeFilters if values are Array with length equal to 0
        if (Array.isArray(filter.values) && filter.values.length === 0) return

        // set the key and values in activeFilters
        this.$set(this.activeFilters, filter.key, filter.values)
      })

      this.filter = filters
    },
    async handleClickShowVideo(data) {
      if (data.statusDownload === 'I' || data.statusDownload === 'F') return
      this.track('Play Video History')
      this.videoPlayerData = data
      await this.$nextTick()
      this.$bvModal.show('video-saved')
    },
    resetVideoData() {
      this.videoPlayerData = null
    },
    handleClickDownloadVideo(data) {
      this.track('Download Video History to Local Storage')
      const hasAccessConvertVideo = this.hasAccess(['b3q-trackvision-convert-video-download:read'])
      if (hasAccessConvertVideo) {
        this.convertAndDownload(data)
      } else {
        this.directDownload(data)
      }
    },
    async convertAndDownload(data) {
      const path = this.extractPathFromDomain(data.videoUrl)
      this.loadingDownloadIds.push(data.id)
      try {
        const res = await fetch(process.env.VUE_APP_API_CONVERT_VIDEO + '/' + path, {
          method: 'GET',
        })
        if (!res.ok) throw new Error('Failed to fetch file')
        const blob = await res.blob()
        const downloadUrl = window.URL.createObjectURL(blob)
        let filename = data.mediaFilename
        const contentDisposition = res.headers.get('Content-Disposition')
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/)
          if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1]
          }
        }
        this.downloadFile(downloadUrl, filename)
      } catch (error) {
        this.$mcToast.error('Failed convert video')
      } finally {
        this.loadingDownloadIds = this.loadingDownloadIds.filter((id) => id !== data.id)
      }
    },
    directDownload(data) {
      this.downloadFile(data.videoUrl, data.mediaFilename)
    },
    setDefaultFields() {
      const defaultFields = this.fields.map((field) => {
        if (!Object.prototype.hasOwnProperty.call(field, 'shown')) field.shown = true
        return field
      })
      if (!localStorage.getItem('downloadVideoHistoryFields')) {
        localStorage.setItem(
          'downloadVideoHistoryFields',
          JSON.stringify({ column: defaultFields })
        )
      }
    },
    handleFieldShow(fields) {
      localStorage.setItem('downloadVideoHistoryFields', JSON.stringify({ column: fields }))
    },
  },
}
</script>

<style lang="scss">
.mc-download-video-history__license-plate {
  color: $mep-primary;
  cursor: pointer;
  &.download-in-progress,
  &.download-failed {
    color: $teal-200;
    cursor: default;
  }
}
</style>
